import { ModalV3 } from '@common/component';
import React from 'react';
import { ActivityIndicator, View, StyleSheet } from 'react-native';
import SearchBar from 'react-native-elements/dist/searchbar/SearchBar-ios';
import { THEME_COLORS } from '@common/themes';
import PodVerifierListing from './PodVerifierListing';

const PodAssignmentModal = ({
  visible,
  listToRender,
  disabledConfirm,
  listLoading,
  selectedVerifier,
  setSelectedVerifier,
  toggleModal,
  podVerifierSearch,
  setPodVerifierSearch,
  onConfirm,
  canLoadMorePages,
  onEndReached,
}) => {
  const role = 'POD Verifier';
  const rowData = visible;
  const currentVerifier = listToRender.length > 0 && rowData?.podVerifierData?.currentPodVerifierName;

  return (
    <ModalV3
      visible={visible}
      header={currentVerifier ? `${role} Re-Assignment` : `${role} Assignment`}
      subheader={"Please select the POD Verifier"}
      onCancel={() => {
        toggleModal(null);
        setPodVerifierSearch("");
        setSelectedVerifier(null);
      }}
      onConfirm={onConfirm}
      confirmButtonText={currentVerifier ? `Re-assign ${role}` : `Assign ${role}`}
      disabledConfirm={disabledConfirm}
    >
      <SearchBar
        placeholder={"Search with POD Verifier...."}
        onChangeText={setPodVerifierSearch}
        value={podVerifierSearch}
        inputContainerStyle={styles.modalSearch}
        inputStyle={{ outline: "none", fontSize: 15 }}
        cancelButtonTitle=""
        cancelButtonProps={{ buttonStyle: { width: 8 } }}
      />

      {listLoading ? (
        <View style={[styles.flexBox, { justifyContent: "center" }]}>
          <ActivityIndicator size="large" color={THEME_COLORS.purple} />
        </View>
      ) : (
        <PodVerifierListing
          data={listToRender}
          selected={selectedVerifier}
          onSelect={setSelectedVerifier}
          canLoadMorePages={canLoadMorePages}
          onEndReached={onEndReached}
        />
      )}
    </ModalV3>
  );
};

const styles = StyleSheet.create({
    modalSearch: {
      backgroundColor: 'transparent',
    },
    flexBox: { flexDirection: 'row', alignItems: 'center' },
  });

export default PodAssignmentModal;